import Request from 'utils/request';
import config from 'config/Config';

// 获取享包邮产品列表
export const apiGetFreeShippingList = async (data) => {
  return Request({
    url: 'item/freeShipping/freeShippingItemData',
    host: config.HOST_MALL
  });
};

export const apiGetFreeShippingAmount = async (tradeNo) => {
  return Request({
    url: 'order/international/queryAmountInfo',
    host: config.HOST_MALL,
    method: 'get',
    params: { tradeNo }
  });
};

export const apiGetAddressList = async () => {
  return Request({
    url: `tradecore/member/address/queryByPage`,
    host: config.HOST_MALL,
    params: {
      pageNum: 1,
      pageSize: 100
    }
  });
};



// WEBPACK FOOTER //
// ./src/pages/Shop/Product/FreeShipping/FreeShippingServ.js